// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__2Ra5M","content":"section_content__1SE5e","files":"section_files__AbiWj","links":"section_links__1z6rO"};